export default __webpack_public_path__ + "static/media/ff-screen1.5ec6503b.png";